import create from 'zustand';

import { ModalStateEnum } from '../types';

type State = {
  activeModal: ModalStateEnum;
  setActiveModal: (newActiveModal: ModalStateEnum) => void;
};

export const useModalStore = create<State>((set) => ({
  activeModal: ModalStateEnum.CLOSE,
  setActiveModal: (newActiveModal: ModalStateEnum) => set(() => ({ activeModal: newActiveModal })),
}));

// To see all the changes happening, uncomment the next line:
// const unsub = useModalStore.subscribe(console.log);
